import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ShieldCheck, Loader2, Upload } from "lucide-react";
import { API } from "../../App";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";

const VERDICTS = {
  detected: ["Bar Songz mark detected", "text-green-700 bg-green-50 border-green-200"],
  possible: ["Possible match: weak signal", "text-amber-800 bg-amber-50 border-amber-200"],
  not_detected: ["No Bar Songz mark found", "text-muted-foreground bg-secondary/40 border-border"],
};

export const WatermarkCheckCard = ({ token }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const check = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    setResult(null);
    try {
      const r = await axios.post(`${API}/admin/preview-page/watermark-check`, fd, { headers: { Authorization: `Bearer ${token}` } });
      setResult({ ...r.data, name: file.name });
    } catch (e) {
      toast.error(e.response?.data?.detail || "Check failed");
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  const [label, cls] = result ? VERDICTS[result.verdict] : [];
  return (
    <Card data-testid="watermark-check-card">
      <CardHeader><CardTitle className="flex items-center gap-2 text-lg"><ShieldCheck className="h-5 w-5 text-gold" /> Check a suspected copy</CardTitle></CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-muted-foreground">
          Found the preview posted somewhere? Upload the audio or video file (MP3, M4A, WAV, MP4, MOV, up to 80 MB) to check it for the hidden Bar Songz ownership mark.
        </p>
        <input ref={ref} type="file" accept="audio/*,video/*" className="hidden" onChange={(e) => check(e.target.files?.[0])} data-testid="watermark-check-input" />
        <Button variant="outline" onClick={() => ref.current?.click()} disabled={busy} data-testid="watermark-check-btn">
          {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Upload className="mr-2 h-4 w-4" />}
          {busy ? "Analyzing…" : "Upload a file to check"}
        </Button>
        {result && (
          <div className={`rounded-lg border p-3 text-sm ${cls}`} data-testid="watermark-check-result">
            <p className="font-semibold">{label}</p>
            <p className="text-xs opacity-80">{result.name} · {result.seconds}s analyzed · signal score {result.score} (8+ = confirmed)</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
